import React, {} from "react";
import AppFooter from "../Components/Footer"


function Faqs() {
  return (
    <div className="w-full flex flex-col">
     
      <div className=" px-32 pt-2   flex-1 flex justify-center">
        <div className="w-2/3">
        <img className="my-4" alt="app icon" src={require("../images/icons/logo.png")} />
          <h1 className="font-bold text-2xl">Frequently asked questions:</h1>

          <h1 className="mt-8 font-bold">Q1: How to reconnect QuickBooks Online in "Ignite for QuickBooks Sync"?</h1>
          <p>Ignite Connector on your Shopify App Store will allow you to integrate your Shopify store with your accounting system within minutes using our simple setup process. Below is a step by step walkthrough process</p>
            <p>Go to "Ignite for QuickBooks Sync" home page, click "Connect to QuickBooks" button.
                 Login to your QuickBooks company and select the company you want to connect with Shopify app. </p>
 
          <div className="grid grid-cols-12 w-full mb-8 gap-10 ">
              <div className="col-span-12 border-2">
                  <img alt="how_to_connect_1" src={require("../images/icons/faqs/how_to_connect_1.png")}/>
                  <h1 className="text-center mt-2">1</h1>
              </div>
              <div className="col-span-12 border-2 flex justify-center">
                <div>
                  <img alt="how_to_connect_2" src={require("../images/icons/faqs/how_to_connect_2.png")}/>
                  <h1 className="text-center mt-2">2</h1>
                </div>
              </div>

          </div>

          
        </div>
      </div>
      <div className="flex-none bg-red-200">
          <AppFooter/>
      </div>
    </div>
  );
}

export default Faqs;
